import React from 'react';
import Subject from './Subject';
import '../../../CommonCSS/SocietyCSS.css'

const SubjectApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Subjects</h5>
          </div>  
        </div>
        <Subject/>
      </div>
    </div >
  );
};

export default SubjectApp;
